var React = require('react');

function IconArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.633803 1.87578C0.796557 1.87578 0.953051 1.9384 1.07825 2.05737L5.00313 5.996L8.93427 2.06363C9.1784 1.81942 9.57277 1.81942 9.8169 2.06363C10.061 2.30784 10.061 2.70233 9.8169 2.94654L5.44131 7.32349C5.20344 7.56144 4.7903 7.56144 4.55869 7.32349L0.183099 2.94654C-0.0610328 2.70233 -0.0610328 2.30784 0.183099 2.06363C0.314554 1.9384 0.471048 1.87578 0.633803 1.87578Z"}));
}

IconArrowDown.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = IconArrowDown;

IconArrowDown.default = IconArrowDown;
